export default {
  upload: {
    tab_title: 'Загрузить',
    browse_your_computer: 'Обзор компьютера',
    or: 'или',
    enter_url_to_upload_from_web: 'Введите URL для загрузки из Интернета',
    upload_btn: 'Загрузить',
    drag_file_here: 'Перетащите файл сюда',
    accepted_file_types: 'Допустимые типы файлов',
    accepted_file_size: 'До 10 МБ.',
    uploading: 'Загрузка...',
    error: 'Ошибка',
    url_not_valid: 'неправильный URL!',
    empty_url: 'пустой URL!',
    search: 'Поиск',
    found: 'Найдено',
    apply: 'Применить',
    categories: 'Категории',
    file_already_exists: 'Файл уже существует в галерее',
    invalid_file_extension: 'Неверное расширение файла',
    all: 'Все',
    too_small: 'Нет поддержки на мобильных устройствах',
    close: 'Закрыть',
    image_editor: 'Редактор изображения',
    smart_crop: 'Умная обрезка',
    face_detection: 'Распознавание лиц',
    resize: 'Изменить размер',
    width: 'Ширина',
    height: 'Высота',
    revert: 'Вернуть',
    crop: 'Обрезать',
    crop_and_resize: 'Обрезать / Изменить размер',
    cancel: 'Отменить',
    selected_files: 'Добавленные файлы',
    total_size: 'размер',
    sort: 'Сортировать',
    name: 'Имя',
    size: 'Размер',
    type: 'Тип',
    modified: 'Изменен',
    uploaded: 'Загружен',
    product_position: 'Позиция',
    product_ref: 'Product reference'
  },
  file_manager: {
    tab_title: 'Галерея',
    search_by_file_name_tag_desc: 'поиск по имени файла, тегу или описанию',
    upload_images: 'Загрузить изображения',
    drag_images_here: 'Перетащите изображения сюда',
    change_folder: 'Изменить папку',
    media_library: 'Медиагалерея',
    go_back: 'Назад',
    select: 'Выбрать',
    tag: 'Изменить',
    edit: 'Редактировать',
    delete: 'Удалить',
    no_subfolders: 'Нет подпапок'
  },
  icons: {
    tab_title: 'Иконки',
    zero_icons_was_found: '0 иконок найдено :(',
    set_icon_as_not_relevant: 'Установить как не релевантную',
    you_can_search_icons_here: 'Вы можете искать иконки здесь',
    color_filter: 'Фильтр',
    all: 'Все',
    multi_color: 'Многоцветный',
    mono_color: 'Моно цвет',
    customize_your_icon: 'Настройте иконку',
    theme_colors: 'Цвета темы',
    apply: 'Применять',
    new_tag_successfully_added: 'Новый тег успешно добавлен!'
  },
  images: {
    tab_title: 'Изображения',
    zero_images_was_found: '0 изображений найдено :(',
    color_filter: 'Цветовой Фильтр',
    add_color: 'добавить цвет',
    images: 'Фон',
    you_can_search_images_here: 'Вы можете искать изображения здесь'
  },
  tagging: {
    tab_title: 'Метаданные',
    something_went_wrong_try_again: 'что-то пошло не так, попробуйте еще раз',
    will_automatically_generate_tags: 'Автоматически генерировать теги на основе технологии распознавания изображений',
    go_back: 'Вернуться',
    file_name: 'Имя файла',
    size: 'Размер',
    first_upload: 'Первая загрузка',
    last_modified: 'Последнее изменение',
    add_description: 'Добавить описание',
    add_a_tag_separate_by_pressing_enter: 'Добавить тег (отделите нажатием Enter)',
    generate_tags: 'Создать теги',
    save: 'Сохранить',
    asset_could_not_be_automatically_tagged: 'Asset could not be automatically tagged',
    auto_tagging_processing: 'Auto-tagging processing...',
    product_ref: 'Product ref',
    product_position: 'Product position',
    not_set: 'Not set',
    update_product_ref: 'Update product ref',
    update_product_position: 'Update product position',
    updating: 'updating...'
  }
};